import { faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import ScreenReader from 'utils/ScreenReader';

import 'view/style/common/buttons.css';

interface AudioAssistanceButtonProps {
  text: string;
  lang?: string;
  audioSrc?: string;
  className?: string;
}

export const AudioAssistanceButton: React.FC<AudioAssistanceButtonProps> = ({
  text,
  lang,
  audioSrc,
  className,
}) => {
  const [audio, setAudio] = useState<HTMLAudioElement>();

  const speakWord = () => {
    if (audioSrc) {
      if (!audio) {
        const newAudio = new Audio(audioSrc);
        setAudio(newAudio);
        newAudio.play().catch(() => {
          ScreenReader.speak(text, lang);
        });
      } else {
        audio.play().catch(() => {
          ScreenReader.speak(text, lang);
        });
      }
    } else {
      ScreenReader.speak(text, lang);
    }
  };

  if (!text) return null;

  return (
    <div
      className={`audio-assistance-button${className ? ' ' + className : ''}`}
    >
      <FontAwesomeIcon
        icon={faVolumeUp}
        onClick={speakWord}
        color="var(--dark-blue)"
        size="xs"
        title="Click to listen"
      />
    </div>
  );
};
